<template>

    <Toast/>

    <MenuSimple/>
    <HeadingForms/>

    <div class="px-6 surface-overlay relative">

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div v-show="formReference==='0'" class="surface-section px-4 py-8 md:px-6 lg:px-8">
                        <div class="text-700 text-center">
                            <div class="text-900 font-bold text-5xl mb-3">Invalid Form</div>
                            <div class="text-700 text-2xl mb-5">Please recheck the details.</div>
                        </div>
                    </div>

                    <div v-show="formReference!='0'" class="surface-section px-4 py-8 md:px-6 lg:px-8">

                        <div class="text-700 text-center">
                            <div class="text-900 font-bold text-5xl mb-3">Booking for {{ this.companyName }}</div>

                            <div class="text-700 text-2xl mb-3">Enter your details below</div>

                        </div>
                    </div>


                    <div v-show="formReference!='0'" class="col-12 md:col-12">
                        <div class="card p-fluid">

                            <h2>Personal Details</h2>

                            <div class="field">
                                <label for="firstName">First Name</label>
                                <InputText id="firstName" v-model.trim="formData.firstName" required="true"/>
                            </div>

                            <div class="field">
                                <label for="lastName">Last Name</label>
                                <InputText id="lastName" v-model.trim="formData.lastName" required="true"/>
                            </div>

                            <div class="field">
                                <label for="preferredName">Preferred Name</label>
                                <InputText id="preferredName" v-model.trim="formData.preferredName" required="false"/>
                            </div>

                            <div class="field">
                                <label for="email">Email</label>
                                <InputText id="email" v-model.trim="formData.email" required="true"/>
                            </div>

                            <div class="field">
                                <label for="mobile">Mobile</label>
                                <InputText id="mobile" v-model.trim="formData.mobile" required="true"/>
                            </div>

                            <div class="field">
                                <label for="phone">Alternate Phone Number</label>
                                <InputText id="phone" v-model.trim="formData.phone" required="true"/>
                            </div>

                            <h2>Practitioner and Location Information</h2>

                            <div class="field">
                                <label for="type">Practitioners</label>
                                <Dropdown v-model="formData.practitioner" :options="this.practitioners"
                                          optionLabel="firstName"
                                          optionValue="id"
                                          placeholder="Select a Practitioner"/>
                            </div>

                            <div class="field">
                                <label for="type">Locations</label>
                                <Dropdown v-model="formData.location" :options="this.locations"
                                          optionLabel="name"
                                          optionValue="id"
                                          placeholder="Select a Location"/>
                            </div>

                            <h2>Booking Preference</h2>

                            <div class="field">
                                <label for="option1">Option #1</label>
                                <Calendar id="option1" v-model="formData.option1" required="true"
                                          :showTime="true"
                                          :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                            </div>

                            <div class="field">
                                <label for="option2">Option #2</label>
                                <Calendar id="option2" v-model="formData.option2" required="true"
                                          :showTime="true"
                                          :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                            </div>

                            <div class="field">
                                <label for="option3">Option #3</label>
                                <Calendar id="option3" v-model="formData.option3" required="true"
                                          :showTime="true"
                                          :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                            </div>

                            <h2>Consent</h2>

                            <h3>Important Guidelines</h3>
                            <p>
                                1. As we work on an appointment based schedule, we ask that you please be on time for
                                your
                                appointments. If you are late for a session it will still end at the scheduled time.
                                If you are more than 15 minutes late for a session, it will be considered a no-show and
                                you will be
                                required to pay the fee for the session.
                                Cancellations should be made at least 24 hours before the scheduled appointment. Failure
                                to cancel a
                                session within this time will result in you being charged for the session.
                                Should you wish to reschedule an appointment, a minimum of 8 working hours notice is
                                required. We will do
                                our best to accommodate this.
                                2. If not already completed, a detailed client intake form will need to be completed
                                which will outline all
                                terms related to our terms and conditions.
                            </p>

                            <div class="field">
                                <label for="diagnosisCodePermission">Do You Give Permission for the company and practice
                                    to Submit the Diagnosis Code/s to Medical Aid?</label>
                                <Dropdown v-model="formData.diagnosisCodePermission" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="billingCompanyPermission">I have understood that the company and practice
                                    may make use of an external practice administration company
                                    and grant permission for them to contact me in regards to any queries about my
                                    account.</label>
                                <Dropdown v-model="formData.billingCompanyPermission" :options="confirmationTypes"
                                          optionLabel="name" required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="softwarePermission">I have understood that the company and practice may make
                                    use of a billing, accounting
                                    and/or practice management software.</label>
                                <Dropdown v-model="formData.softwarePermission" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <div class="field">
                                <label for="termsPermission">I hereby declare that the information given in this form is
                                    true and
                                    correct to the best of
                                    my knowledge and belief.</label>
                                <Dropdown v-model="formData.termsPermission" :options="confirmationTypes"
                                          optionLabel="name"
                                          required="true"
                                          optionValue="code"
                                          placeholder="Select an Option"/>
                            </div>

                            <Button
                                v-show="formData.diagnosisCodePermission === 'N' || formData.billingCompanyPermission === 'N' || formData.softwarePermission === 'N' || formData.softwarePermission === 'N' || formData.termsPermission === 'N'"
                                label="Save" class="mr-2 mb-2" @click="saveForm" :disabled="true"></Button>

                            <Button
                                v-show="formData.diagnosisCodePermission === 'Y' && formData.billingCompanyPermission === 'Y'&& formData.softwarePermission === 'Y' && formData.termsPermission === 'Y'"
                                label="Save" class="mr-2 mb-2" @click="saveForm" :disabled="false"></Button>

                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import MenuSimple from "@/components/menu/common/MenuSimple.vue";
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import HeadingForms from "@/components/heading/common/HeadingForms.vue";
import UserService from "@/service/UserService";
import AppointmentService from "@/service/AppointmentService";
import CompanyService from "@/service/CompanyService";
import PractitionerService from "@/service/PractitionerService";
import LocationService from "@/service/LocationService";
import moment from "moment/moment";


export default {
    name: "Booking",
    components: {
        MenuSimple,
        HeadingForms,
        IsoEvolveFooter,
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[Form][mounted] System is active.");
                console.log("[Form][mounted] Data = ", data);

                this.formReference = this.$route.query.reference;
                this.formData.addressCountry = 'ZA';
                this.formData.diagnosisCodePermission = 'Y';
                this.formData.billingCompanyPermission = 'Y';
                this.formData.softwarePermission = 'Y';
                this.formData.termsPermission = 'Y';

                this.formData.mailingList = 'Y';
                this.formData.responsiblePerson = 'Y';
                this.formData.paymentMethod = 'M';

                console.log("[Booking] Company Reference (as per route parameter) = ", this.$route.query.reference);

                // CompanyService.getCompany(this.$route.query.reference)

                CompanyService.getCompany(this.$route.query.reference)
                    .then(data => {
                        this.company = data.data;
                        this.companyName = this.company.name;
                        console.log("[" + name + "][Booking] Got company data = ", this.company);

                        PractitionerService.getCompanyPractitioners(this.company.id)
                            .then(data => {
                                console.log("[MsConfiguration][mounted] Getting practitioner data for company = ", this.company.id);
                                this.practitioners = data.data;
                                console.log("[MsConfiguration][mounted] Got practitioner data = ", data.data);
                            })
                            .catch(e => {
                                console.log("[MsConfiguration][mounted] Could not get practitioner data for company = ", this.company.id);
                                console.log("[MsConfiguration][mounted] Error = ", e);
                            });

                        LocationService.getCompanyLocations(this.company.id)
                            .then(data => {
                                this.locations = data.data;
                                console.log("[MsConfigurationLocation][mounted] Got locations for company = ", this.company.id);
                                console.log("[MsConfigurationLocation][mounted] Got location data = ", data.data);
                            })
                            .catch(e => {
                                console.log("[MsConfigurationLocation][mounted] Could not get locations for company = ", this.company.id);
                                console.log("[MsConfigurationLocation][mounted] Error = ", e);
                            });

                    })
                    .catch(e => {
                        console.log("[" + name + "][Booking] Could not get data for company with ID = ", this.$route.query.reference);
                        console.log("[" + name + "][callViewBillingPlanComponents] Error = ", e);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Unsuccessful',
                            detail: 'Company NOT Found',
                            life: 3000
                        });

                        window.location.href = "/#/login";
                        window.location.reload();

                    });


            }).catch(e => {
            console.log("[Form][mounted] System is NOT active.");
            console.log("[Form][mounted] Error = ", e);

            window.location.href = "/#/login";
            window.location.reload();
        });
    },
    data() {
        return {
            userData: {},
            company: {},
            submitted: false,
            form: {},
            formData: {},
            companyName: null,
            practitioners: null,
            locations: null,
            newFormComponents: [],
            newForm: {},
            formOwner: "0",
            genderTypes: [
                {name: 'Male', code: 'M'},
                {name: 'Female', code: 'F'},
                {name: 'Other', code: 'O'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            parentTypes: [
                {name: 'Mother', code: 'M'},
                {name: 'Father', code: 'F'}
            ],
            paymentTypes: [
                {name: 'Medical Aid', code: 'M'},
                {name: 'Cash', code: 'C'}
            ],
            countries: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'India', code: 'IN'},
                {name: 'United States', code: 'US'},
                {name: 'Namibia', code: 'NA'},
                {name: 'Australia', code: 'AU'},
                {name: 'New Zealand', code: 'NZ'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'Slovenia', code: 'SV'},
                {name: 'Taiwan', code: 'TW'},
                {name: 'Other', code: 'OT'}
            ],
            regionsSouthAfrica: [
                {name: 'Gauteng', code: 'Gauteng'},
                {name: 'Western Cape', code: 'Western Cape'},
                {name: 'Kwa-Zulu Natal', code: 'Kwa-Zulu Natal'},
                {name: 'North-West', code: 'North-West'},
                {name: 'Free State', code: 'Free State'},
                {name: 'Eastern Cape', code: 'Eastern Cape'},
                {name: 'Mpumalanga', code: 'Mpumalanga'},
                {name: 'Northern Cape', code: 'Northern Cape'},
                {name: 'Limpopo', code: 'Limpopo'}
            ]
        }
    }
    ,
    methods: {
        convertDatetoUtc(inputDate) {
            // const inputDateStr = "23-10-31";

            // Split the input date string into year, month, and day components
            // const [yy, mm, dd] = inputDate.split("-");
            //
            // // Create a new Date object by specifying year, month (0-based), and day
            // const utcDate = new Date(`20${yy}`, mm - 1, dd);

            // Get the UTC date and time string in the desired format
            const formattedDateStr = inputDate.toLocaleString();

            return formattedDateStr;
        }
        ,
        saveForm() {
            console.log("[Form][saveForm] Start of function.");

            this.submitted = true;

            console.log("[Form][saveForm] this.formData.practitioner = ", this.formData.practitioner);
            console.log("[Form][saveForm] this.formData.location = ", this.formData.location);

            console.log("[Form][saveForm] this.formData.option1 = ", this.formData.option1);
            console.log("[Form][saveForm] this.formData.option2 = ", this.formData.option2);
            console.log("[Form][saveForm] this.formData.option3 = ", this.formData.option3);

            var option1Utc = null;
            var option2Utc = null;
            var option3Utc = null;

            if (this.formData.option1) {
                option1Utc = this.convertDatetoUtc(this.formData.option1);
                console.log("[Form][saveForm] option1Utc = ", option1Utc);
            }

            if (this.formData.option2) {
                option2Utc = this.convertDatetoUtc(this.formData.option2);
                console.log("[Form][saveForm] option2Utc = ", option2Utc);
            }

            if (this.formData.option3) {
                option3Utc = this.convertDatetoUtc(this.formData.option3);
                console.log("[Form][saveForm] option3Utc = ", option3Utc);
            }

            var bookingDto = {
                firstName: this.formData.firstName,
                lastName: this.formData.lastName,
                preferredName: this.formData.preferredName,
                email: this.formData.email,
                mobile: this.formData.mobile,
                practitionerId: this.formData.practitioner,
                locationId: this.formData.location,
                option1: moment(this.formData.option1).format('YYYY-MM-DD HH:mm'),
                option2: moment(this.formData.option2).format('YYYY-MM-DD HH:mm'),
                option3: moment(this.formData.option3).format('YYYY-MM-DD HH:mm'),
                diagnosisCodePermission: this.formData.diagnosisCodePermission,
                billingCompanyPermission: this.formData.billingCompanyPermission,
                softwarePermission: this.formData.softwarePermission,
                termsPermission: this.formData.termsPermission
            };

            console.log("[Form][saveForm] Before update call. bookingDto = ", bookingDto);

            AppointmentService.createBooking(this.company.id, bookingDto)
                .then(response => {
                    console.log("[" + name + "][saveForm] Response = ", response);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Booking Submitted',
                        life: 3000
                    });

                    window.location.href = "/#/bookingSuccessful";
                    window.location.reload();

                })
                .catch(e => {

                    console.log("[" + name + "][saveForm] Error = ", e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Unsuccessful',
                        detail: 'Booking NOT Submitted',
                        life: 3000
                    });

                    window.location.href = "/#/bookingError";
                    window.location.reload();

                });

            this.formData.firstName = "";
            this.formData.lastName = "";
            this.formData.preferredName = "";
            this.formData.email = "";
            this.formData.mobile = "";
            this.formData.option1 = "";
            this.formData.option2 = "";
            this.formData.option3 = "";

            this.newFormComponents = [];
            this.newForm = {};
            this.submitted = false;

        }
        ,


    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
